export const EVENT_TYPE_PAUSE = 'pause';

export const PROGRAMMATION_PAUSE_KINDS = [
    { kind: 'changeover', duration: 10, public: false, sets_break: false },
    { kind: 'intermission', duration: 15, public: false, sets_break: true },
    { kind: 'qa', duration: 20, public: true, sets_break: false },
    { kind: 'presentation', duration: 10, public: true, sets_break: false },
];

export function programmation_pause_kind(kind) {
    return PROGRAMMATION_PAUSE_KINDS.find((row) => row.kind === kind) || null;
}

export function is_programmation_pause(ev) {
    return !!(ev && (ev.type === EVENT_TYPE_PAUSE || ev.event_type === EVENT_TYPE_PAUSE));
}

export function is_public_programmation_pause(ev) {
    if (!is_programmation_pause(ev))
        return false;
    const def = programmation_pause_kind(ev.pause_kind);
    if (def)
        return !!def.public;
    return ev.public === true;
}
